import { useRef } from "react";

import config from "config/appConfig";

import type { Scrollbars } from "react-custom-scrollbars-2";

import { ErrorBoundary } from "react-error-boundary";

import { useTranslation } from "react-i18next";

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ToastContainer } from "react-toastify";

import ErrorFallback from "shared/Components/ErrorFallback";
import ScrollToTop from "shared/Components/ScrollToTop";
import { AccessDenied } from "shared/Errorpages";
import SecureRoute from "shared/services/AuthDecorator/SecureRoute";
import Loader from "shared/uikit/Loader";

import "./i18n";

const RoutesBlock: React.FC<{ modules: (() => any)[] }> = ({ modules }) => {
	const scrollerRef = useRef<Scrollbars | null>(null);

	const { ready } = useTranslation();

	if (!ready) {
		return <Loader />;
	}

	return (
		<>
			<BrowserRouter key="root">
				<ScrollToTop scrollRef={scrollerRef} />
				<ErrorBoundary FallbackComponent={ErrorFallback}>
					<Routes>
						<Route key={"AccessDenied"} path="/AccessDenied" element={<AccessDenied />} />
						{modules.map(Module => Module())}
						{/* if user authorized, then redirect to home page otherwise to sign in page */}
						<Route element={<SecureRoute />}>
							<Route path="*" element={<Navigate to={{ pathname: config.CORE_URLS.LAUNCH }} replace />} />
						</Route>
					</Routes>
				</ErrorBoundary>
			</BrowserRouter>
			<ToastContainer />
		</>
	);
};

export default RoutesBlock;
